const uiConstants = {
  UI_HEADER_BREADCRUMBS_UPDATE: 'UI_HEADER_BREADCRUMBS_UPDATE',
  SUPPLIERS_FILTER_UPDATE: 'SUPPLIERS_FILTER_UPDATE'
};

export default uiConstants;
